import axios from 'axios';


// API URL
const RAW_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
// If REACT_APP_API_URL is a full URL (e.g., http://mngldodo.zapto.org:5000), API_BASE will be that URL.
// If REACT_APP_API_URL is a relative path (e.g., /api for proxying), API_BASE will be an empty string, 
// and axios calls will use the current origin + /api.
const API_BASE = RAW_API_URL.startsWith('http') ? RAW_API_URL : '';

// Set axios to send credentials with requests
axios.defaults.withCredentials = true;

/**
 * Check if user is authenticated
 * @returns Promise resolving to authentication status
 */
export const checkAuth = async (): Promise<{ authenticated: boolean; email?: string }> => {
  try {
    // Use vanilla fetch API instead of axios to avoid any configuration issues
    // Construct the URL correctly to avoid duplicate /api/ paths
    const baseUrl = RAW_API_URL.endsWith('/api') || RAW_API_URL.endsWith('/api/') 
      ? RAW_API_URL 
      : `${RAW_API_URL}/api`;
    const response = await fetch(`${baseUrl}/auth/check`, {
      method: 'GET',
      credentials: 'include', // Critical for sending cookies
      headers: {
        'Accept': 'application/json'
      }
    });
    
    if (!response.ok) {
      console.log('[checkAuth] Authentication failed with status:', response.status);
      return { authenticated: false };
    }
    
    const data = await response.json();
    console.log('[checkAuth] Auth check response:', data);
    return data;
  } catch (error) {
    console.error('[checkAuth] Error checking authentication:', error);
    return { authenticated: false };
  }
};

/**
 * Get user email from cookie
 * @returns User email or null
 */
export const getUserEmail = (): string | null => {
  // Try to get email from cookie (accessible to JavaScript)
  const cookies = document.cookie.split(';');
  const userEmailCookie = cookies.find(cookie => cookie.trim().startsWith('user_email='));
  
  if (userEmailCookie) {
    return decodeURIComponent(userEmailCookie.split('=')[1]);
  }
  
  return null;
};

/**
 * Logout user by clearing cookies
 * @returns Promise resolving to logout status
 */
export const logout = async (): Promise<{ success: boolean }> => {
  try {
    // Clear session tracking flags
    sessionStorage.removeItem('isLoggedIn');
    sessionStorage.removeItem('userProfileData');
    sessionStorage.removeItem('currentApplicationId');
    sessionStorage.removeItem('editingUser');
    
    const response = await axios.post(`${API_BASE}/api/logout`);
    return response.data;
  } catch (error) {
    console.error('Logout failed:', error.response ? error.response.data : error.message || error);
    return { success: false };
  }
};
